import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/ui/Icon';
import { uiIcons } from '@/constants/uiIcons';

interface BooleanProps {
  value: boolean | null | undefined;
  showFalse?: boolean;
}

export const Boolean = ({ value, showFalse = true }: BooleanProps) => {
  const { t } = useTranslation('ui');

  // Handle null/undefined values
  if (value == null) {
    return null;
  }

  if (showFalse === false && value === false) {
    return null;
  }

  if (value === false) {
    return (
      <Icon
        name={uiIcons.state.disabled}
        size="medium"
        aria-label={t('No')}
        title={t('No')}
        disabled
      />
    );
  }

  // Only render "Yes" icon for truthy values (true)
  if (value === true) {
    return (
      <Icon
        name={uiIcons.status.success}
        size="medium"
        color="secondary"
        aria-label={t('Yes')}
        title={t('Yes')}
      />
    );
  }

  // Fallback for unexpected values
  return null;
};
